import React from "react";
import _ from "lodash";
import moment, { Moment } from "moment";
import { compose } from "recompose";
import { connect } from "react-redux";
import { Dispatch, bindActionCreators } from "redux";
import { Action, ActionCreator } from "typescript-fsa";

import { Api, makePlaylistsShow } from "@api/index";
import { connectToApi } from "@api/components/connectToApi";
import { ApiButton } from "@api/components/ApiButton";
import { MAX_FILTER_DAYS } from "@sales/constants";
import { DownloadCsvButton } from "@ui/DownloadCsvButton";
import { PresetDateRangePicker } from "@ui/PresetDateRangePicker";
import { messages as uiMessages } from "@ui/messages";
import { PlaylistSelect } from "../PlaylistSelect";
import { messages } from "../../messages";
import { setPlaylistFilters } from "../../actions";
import { PlaylistFilters as Filters, VendorState } from "../../models";
import { getPlaylistFilters } from "../../selectors";
import { FormattedMessage } from "react-intl";

interface OwnProps {
    id?: number;
    onChange?: (filters: Filters) => void;
    onFilter?: (filters: Filters) => void;
}

interface StateProps {
    filters: Filters;
    downloadAction: () => Action<any>;
}

interface DispatchProps {
    setFilters: ActionCreator<Filters>;
}

type Props = OwnProps & StateProps & DispatchProps;

class PlaylistsFilters extends React.Component<Props> {
    private onPlaylistChange(id: number) {
        const { filters } = this.props;
        const newFilters = { ...filters, id };
        this.onChange(newFilters);
    }

    private onDatesChange(from: Moment, to: Moment) {
        const newFilters = { id: this.getId(), from, to };
        this.onChange(newFilters);
    }

    private onChange(filters: Filters) {
        const { setFilters, onChange } = this.props;
        setFilters(filters);
        if (onChange != null) {
            onChange(filters);
        }
    }

    private onFilter() {
        const { onFilter, filters }  = this.props;

        if (onFilter != null) {
            onFilter(filters);
        }

        return Api.playlistsShow(this.getId(), {
            from: filters.from.toDate(),
            to: filters.to.toDate(),
        });
    }

    private getId() {
        if (this.props.filters.id != null) {
            return this.props.filters.id;
        }
        return this.props.id;
    }

    public render() {
        const { downloadAction, filters: { from, to } }  = this.props;
        const id = this.getId();

        return (
            <div className="playlists-filters">
                <div className="playlists-filters__playlist-select">
                    <PlaylistSelect
                        selected={id}
                        onChange={(playlistId: number) => this.onPlaylistChange(playlistId)}
                        placeholderMessage={messages.filterPlaylists}
                    />
                </div>
                <div className="playlists-filters__date-picker">
                    <PresetDateRangePicker
                        startDate={from}
                        startDateId="playlists-filters-from"
                        endDate={to}
                        endDateId="playlists-filters-to"
                        onDatesChange={({ startDate, endDate }) => this.onDatesChange(startDate, endDate)}
                        displayFormat="DD/MM/YYYY"
                        anchorDirection="right"
                        earliestDate={moment("2019-01-01").startOf("day")}
                        latestDate={moment().startOf("day")}
                        presets={[]}
                        maxDays={MAX_FILTER_DAYS}
                    ></PresetDateRangePicker>
                </div>
                <div className="playlists-filters__break"></div>
                <ApiButton
                    noOutline
                    disabled={id == null}
                    color="primary"
                    className="playlists-filters__filter-button"
                    actionCreators={[() => this.onFilter()]}
                >
                    <FormattedMessage {...uiMessages.filter} />
                </ApiButton>
                {" "}
                <DownloadCsvButton
                    disabled={id == null}
                    actionCreator={downloadAction}
                    className="playlists-filters__download-button"
                />
            </div>
        );
    }
}

const mapStateToProps = (state: VendorState, { id }: OwnProps) => {
    const filters = getPlaylistFilters(state);
    if (filters.id != null) {
        id = filters.id;
    }
    return {
        filters,
        downloadAction: makePlaylistsShow(id, filters.from, filters.to, true),
    } as StateProps;
};

const mapDispatchToProps = (dispatch: Dispatch<VendorState>): DispatchProps => {
    return {
        setFilters: bindActionCreators(setPlaylistFilters, dispatch),
    };
};

const ConnectedPlaylistsFilters = compose<Props, OwnProps>(
    connectToApi({
        showRefresh: false,
        actionCreator: Api.playlistsIndex,
    }),
    connect(mapStateToProps, mapDispatchToProps),
)(PlaylistsFilters);

export {
    PlaylistsFilters as PlaylistsFiltersPresenter,
    ConnectedPlaylistsFilters as PlaylistsFilters,
};
